import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import axios from "axios";
import "./../style.css";
import "./Performancestyle.css"
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import trueimages from "./../Asset/true-images.png";
import failimages from "./../Asset/fail-images.png";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Select from 'react-select';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { Card, Tooltip, Typography } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import RunReportNow from "../RunReportNow";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import Loader from "../CommonLoader";
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import { datezonechange } from "./../Commonfun";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import rankedkeywordsicon from "../Asset/ESO/rankedkeywords.png";
import RankedKeywordssvg from "../Asset/esocardicon/FileAccessibilityReport/Score.svg";
import { useMediaQuery } from "react-responsive";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Chart from "react-apexcharts";
import ScoreGauge from "../../../Components/chart/gaugeChart";


export default function Performancelist() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const esodata = useSelector((state) => state);
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([])
  const [Domainsectiondata, SetDomainsectiondata] = useState([])
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [initialDateval, SetInitialDateval] = useState([]);
  const [fataloutCount, setfataloutCount] = useState();
  const [performancePlan, setperformancePlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    ux_distribution: {},
    responsiveness_distribution: {},
    pass_fail_breakdown: {},
    top_5_pages: [],
    bottom_5_pages: [],
    trend: [],
  });

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });


  let detailurl = `${process.env.REACT_APP_DOMAIN}ux-analysis-detail/`;


  const checkUserPlan = async () => {
    const performanceP = await Utils("performance", ApiToken);
    if (performanceP.status) {
      callUserdataApi();
      LoadAddFormFilterOptions();
      faqdatafun();
    }
    setperformancePlan(performanceP);
  };

  useEffect(() => {
    checkUserPlan();
    GetuserDatavalue();
  }, []);

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };


  const columns = [


    {
      field: "link__url",
      headerName: "Page URL",
      description: 'The URL of the web page to monitor usability, accessibility, UX, and performance under URL management settings.',
      minWidth: 320,
      flex: 1,
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        let baseUrl = cardData.row.link__url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.link__url.split("/").slice(3).join("/");

        return (
          <>
            <Tooltip title={cardData.row.link__url}>
              <div className="prefered_url_external02">
                <a
                  target="_blank"
                  href={cardData?.row?.link__url}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span
                    className="spanlink"
                    style={{
                      color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },
    },
    {
      field: "UX_score",
      headerName: "UX Score",
      description: 'UX score for the specific URL or web page',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        return cardData.row.UX_score + "%"
      },
    },
    {
      field: "seo_impact",
      headerName: "Seo Impact",
      description: 'SEO Impact on the specific URL or web page',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "responsiveness",
      headerName: "Responsiveness",
      description: 'Responsiveness of the URL or web page',
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "url_check",
      headerName: "URL Check",
      description: 'URL Accessibility and friendliness check for the URL or web page',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        return cardData.row.url_check === true ? (
          <img
            src={trueimages}
            className="view_per_img"
            alt="view report icon"

          />

        ) : (

          <img
            src={failimages}
            className="view_per_img"
            alt="view report icon"
          />

        );
      },
    },
    {
      field: "html_element",
      headerName: "HTML Element",
      description: 'HTML Elements check for the URL or web page',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        return cardData.row.html_element === true ? (
          <img
            src={trueimages}
            className="view_per_img"
            alt="view report icon"

          />

        ) : (
          <img
            src={failimages}
            className="view_per_img"
            alt="view report icon"
          />

        );
      },
    },
    {
      field: "security",
      headerName: "Security",
      description: 'Secured HTTPS connection check',
      minWidth: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        return cardData.row.security === true ? (
          <img
            src={trueimages}
            className="view_per_img"
            alt="view report icon"

          />

        ) : (
          <img
            src={failimages}
            className="view_per_img"
            alt="view report icon"
          />

        );
      },
    },
    {
      field: "amp",
      headerName: "AMP",
      description: 'AMP (Accelerated Mobile Pages) Compliance check',
      minWidth: 120,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        return cardData.row.amp === true ? (
          <img
            src={trueimages}
            className="view_per_img"
            alt="view report icon"

          />

        ) : (
          <img
            src={failimages}
            className="view_per_img"
            alt="view report icon"
          />

        );
      },
    },
    {
      field: "content",
      headerName: "Content",
      description: 'Content metrics check for a URL or web page.',
      minWidth: 140,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        return cardData.row.content === true ? (
          <img
            src={trueimages}
            className="view_per_img"
            alt="view report icon"

          />

        ) : (
          <img
            src={failimages}
            className="view_per_img"
            alt="view report icon"
          />

        );
      },
    },
    {
      field: "performance",
      headerName: "Performance",
      description: 'Performance metrics check for a URL or web page.',
      minWidth: 160,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        return cardData.row.performance === true ? (
          <img
            src={trueimages}
            className="view_per_img"
            alt="view report icon"

          />

        ) : (

          <img
            src={failimages}
            className="view_per_img"
            alt="view report icon"
          />

        );
      },
    },
    {
      field: "View",
      headerName: "View",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      headerClassName: "hide_option",
      renderCell: (cardData) => {
        return (
          <a href={detailurl + `${cardData.row.link__id}` + "/" + `${jobidData}`}>
            <button className="view-report-button">
              View Report
            </button>
          </a>
        );
      },
    },
  ]

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "", domainsecdata = "", pageNumber = 1, rowsPerPage = 10) => {
    // if (domainsecdata == "")
    //   domainsecdata = Domainsectiondata;
    if (jobid == "")
      jobid = jobidData;
    setLoading(true);
    setTableLoading(true);
    setCardData([])
    try {


      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}technical/v2/performance_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobid}&domain_section_id=${domainsecdata}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (jobidData == "") {
        const completevalues = await axios.get(
          `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=performance&user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${esodata.sectiondomaindata.value}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        ).catch((error) => {
          if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error)
          }
          else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
            navigate('/errorpages')
          }
        });
        // var Selectedmets = [];
        if (completevalues?.data) {
          // completevalues?.data?.jobs.forEach((element) => {
          //   Selectedmets.push({
          //     value: element.id,
          //     label: datezonechange(element.completed_at),
          //   });
          // });
          const uniqueByCompletedAt = removeDuplicateDate(completevalues?.data?.jobs);
          SetInitialDateval(uniqueByCompletedAt[0]);
          setSelectval(uniqueByCompletedAt[0]?.value);
          SetdEngineoption(uniqueByCompletedAt[0]);
          setprevdEngineoption(uniqueByCompletedAt[0]);
          setcompletedate(uniqueByCompletedAt);
        }

      }
      if (datavalue?.data?.job_date)
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
      else
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))

      if (datavalue?.data) {
        const dataval = datavalue.data.table_data;
        var newData = "";
        if (dataval && dataval.length > 0) {
          SetAutoheightval(false)
          const newData = dataval.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          setfataloutCount(datavalue?.data?.report_ux_score)
          setCardData(newData);

          setjobidData(datavalue?.data?.job_id)
          setSelectval(datavalue?.data?.job_id);

          setSummaryData({
            ux_distribution: datavalue?.data?.analytics?.ux_distribution,
            responsiveness_distribution: datavalue?.data?.analytics?.responsiveness_distribution,
            pass_fail_breakdown: datavalue?.data?.analytics?.pass_fail_breakdown,
            top_5_pages: datavalue?.data?.analytics?.top_5_pages || [],
            bottom_5_pages: datavalue?.data?.analytics?.bottom_5_pages || [],
            trend: datavalue?.data?.analytics?.trend,
          });
        }
        else {
          setCardData("");
          SetAutoheightval(true)

        }

      }
    }
    catch (err) {
      console.log('err', err)
    }
    setTableLoading(false);
    setLoading(false);

  };

  const reportNow = async () => {
    setLoading(true);
    var errs = 1;
    let errors = {};
    if (selectval == "") {
      errors.dateerror = "This field is required.";
      errs = 2;
      setLoading(false);
    } else {
      errors.dateerror = "";
      errs = 1;
      setValidation(errors);
    }
    if (errs == 2) {
      return setValidation(errors);
    }
    setjobidData(selectval?.value);
    setIsOpen(false);
    setprevdEngineoption(dEngineoption);
    callUserdataApi(selectval?.value, "");
  };
  function openModal() {
    if (performancePlan.status) {
      setIsOpen(true);
    }
  }
  function closeModal() {
    setSelectval("");
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }
  const [RunReportPopShow, SetRunReportPopShow] = useState(false)
  const [RunReportType, SetRunReportType] = useState('performance')
  const [dEngineoption, SetdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const [prevdEngineoption, setprevdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/performance_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&domain_section_id=${Domainsectiondata}&job_id=${jobidData}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("uxanalysislist", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/performance_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&domain_section_id=${Domainsectiondata}&job_id=${jobidData}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("uxanalysislist", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }
  const LoadAddFormFilterOptions = async () => {
    SetSectionOptions([]);
    try {
      const doaminsectiondatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_domain_sections/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        if (doaminsectiondatavalue?.data?.domain_sections) {

          SetDoaminSectionUrl(doaminsectiondatavalue?.data?.domain_sections)
          var Sections = [];
          doaminsectiondatavalue.data.domain_sections.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetSectionOptions(Sections);
        }
      }
    } catch (err) { }
  }
  const SetSectionNameHandle = (passvalue) => {
    if (passvalue) {
      SetDomainsectiondata(passvalue.value)
      callUserdataApi("", passvalue.value);
    } else {
      SetDomainsectiondata("")
      callUserdataApi();
    }
  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=19`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  // const cardDatas = [
  //   { title: "Total UX Score", value: fataloutCount, iconSrc: RankedKeywordssvg, altText: "Total UX Score" },
  // ];

  const cardDatas = [
    {
      value: fataloutCount || 0,
      title: "Total UX Score",
      badge: "Points",
      iconSrc: RankedKeywordssvg,
      iconColor: 1,
      bgColor: 1,
    },
  ];

  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const getPagination = (pageNumber = 1, rowsPerPage = 10) => {
    callUserdataApi("", Domainsectiondata, pageNumber, rowsPerPage);
  }

  const gaugeChart = () => {
    return (
      <div>
        <ScoreGauge score={fataloutCount} width={'200px'} />
      </div>
    )
  }

  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>

      {loading === true ? <Loader /> : null}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>UX Analysis </title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      <div style={{ color: "#000000", margin: "auto" }}>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    UX Analysis
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Technical' },
                        { title: 'Performance Analysis' },
                        { title: 'UX Analysis', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-time">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={6}>
                <div className="time_zone">
                  <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                  <span className="timezone-val">{timezoneval()}</span>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="drop_down_button" >
                  <Select
                    options={SectionOptions}
                    name="name"
                    onChange={SetSectionNameHandle}
                    placeholder="Domain Section"
                    isClearable
                    styles={customDropdownStyles()}
                    menuPortalTarget={document.body}
                    classNamePrefix="common-domain-dropdown_color"
                  />
                  <button
                    title="Run Report"
                    className="btn_dashboard"
                    onClick={() => {
                      if (first.statusDomain) {
                        setcheckD(first.statusDomain);
                      } else {
                        setfaqData(2)
                        setToggle(false)
                        SetRunReportPopShow(true);
                      }
                    }}
                    disabled={!performancePlan.status}
                  >
                    Run Report Now
                  </button>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
        {/* <Container maxWidth={false} className="dashboard-card-container">
          <Box className="dashboard-box-card">
            <Grid container className="dashboard-card-grid">
              <Grid item xs={12} md={12}>
              
                <div className="common-card-container" style={{ justifyContent: "center" }}>
                  {cardDatas.map(({ title, value, iconSrc, altText }) => (
                    <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
                  ))}
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container> */}
        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-tab">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="trendy-tabs-wrapper">
                  <div className="trendy-tab-container">
                    <button type="button"
                      className="trendy-tab active"  >UX Analysis</button>
                    <button type="button" onClick={e => { navigate('/network-health-summary'); }}
                      className="trendy-tab ">Network Health</button>
                    <button type="button" onClick={e => { navigate('/content-structure-summary'); }}
                      className="trendy-tab" >Content Structure</button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
        {/* <Container maxWidth={false} className="dashboard-card-container">
          <Box className="dashboard-box-card">
            <Grid container className="dashboard-card-grid">
              <Grid container spacing={3} justifyContent="center">
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={item.id}>
                    <Commoncard
                      item={item}
                      nonclikable={true}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Container> */}

        <Container maxWidth={false} className="dashboard-container">
          <Grid container spacing={2} style={{ marginBottom: '20px' }}>

            <Grid item xs={12} md={3}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>UX Distribution</Typography>
                <Chart
                  type="donut"
                  height={240}
                  series={Object.values(summaryData.ux_distribution)}
                  options={{
                    labels: Object.keys(summaryData.ux_distribution),
                    colors: ['#2e7d32', '#4caf50', '#ffb74d', '#ffeb3b', '#fb8c00', '#e53935', '#b71c1c'],
                    legend: { position: 'bottom', fontSize: '10px' },
                    dataLabels: { enabled: false }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Responsiveness Distribution</Typography>
                <Chart
                  type="donut"
                  height={240}
                  series={Object.values(summaryData.responsiveness_distribution)}
                  options={{
                    labels: Object.keys(summaryData.responsiveness_distribution),
                    colors: ['#2e7d32', '#4caf50', '#ffb74d', '#ffeb3b', '#fb8c00', '#e53935', '#b71c1c'],
                    legend: { position: 'bottom', fontSize: '10px' },
                    dataLabels: { enabled: false }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Core Parameter Distribution</Typography>
                <Chart
                  type="donut"
                  height={240}
                  series={Object.values(summaryData.pass_fail_breakdown)}
                  options={{
                    labels: Object.keys(summaryData.pass_fail_breakdown),
                    colors: ['#2e7d32', '#4caf50', '#ffb74d', '#ffeb3b', '#fb8c00', '#e53935', '#b71c1c'],
                    legend: { position: 'bottom', fontSize: '10px' },
                    dataLabels: { enabled: false }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card
                sx={{
                  borderRadius: "16px",
                  boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                  transition: "0.3s",
                  cursor: "default",
                  height: "100%",
                  // border: 1px solid #e0e0e0;
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                  },
                  overflow: "hidden",
                  border: "none"
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#d1fae5',
                    p: 2.5,
                    // display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >

                  <Box
                    sx={{
                      // backgroundColor: '#7c3aed',
                      color: "#059669",
                      // p: 1.5,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.5rem",
                    }}
                  >
                    {/* {icon} */}
                    {gaugeChart()}
                  </Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 700,
                      fontSize: "2.5rem",
                      background: "linear-gradient(to right, #1f2937, #4b5563)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                      letterSpacing: 1,
                    }}
                  >
                    <div style={{ justifySelf: 'center', marginTop: '1rem' }}>{fataloutCount}<span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span></div>
                  </Typography>
                </Box>

                <Box
                  sx={{
                    background: "#fff",
                    px: 2.5,
                    py: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textTransform: "uppercase",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                  >
                    Total UX Score
                  </Typography>
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#2e7d32', marginBottom: '10px' }}>Top 5 Pages</Typography>
                <Chart
                  type="bar"
                  height={200}
                  series={[{ name: "Score", data: summaryData?.top_5_pages.map(i => i.UX_score) }]}
                  options={{
                    chart: { toolbar: { show: false } },
                    plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                    colors: ["#2e7d32"],
                    xaxis: { categories: summaryData?.top_5_pages.map(i => i.link__url), labels: { show: false } },
                    dataLabels: { enabled: true, formatter: (val) => `${val}%`, position: 'right' }
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#d32f2f', marginBottom: '10px' }}>Bottom 5 Pages</Typography>
                <Chart
                  type="bar"
                  height={200}
                  series={[{ name: "Score", data: summaryData.bottom_5_pages.map(i => i.UX_score) }]}
                  options={{
                    chart: { toolbar: { show: false } },
                    plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                    colors: ["#d32f2f"],
                    xaxis: { categories: summaryData.bottom_5_pages.map(i => i.link__url), labels: { show: false } },
                    dataLabels: { enabled: true, formatter: (val) => `${val}%`, position: 'right' }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '250px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Weekly Score Trend</Typography>
                <Chart
                  type="area"
                  height={220}
                  series={[
                    {
                      name: "Score",
                      // data: [4, 5, 6, 6, 77]
                      data: summaryData.trend.map(i => i.avg_ux_score)
                    }
                  ]}
                  options={{
                    chart: {
                      toolbar: { show: false }
                    },
                    colors: ["#ff601f"],
                    stroke: { curve: 'smooth', width: 3 },
                    fill: {
                      type: 'gradient',
                      gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.4,
                        opacityTo: 0.1
                      }
                    },
                    xaxis: {
                      // categories: ['Apr 12', 'Apr 13', 'Apr 14', 'Apr 15', 'Apr 16'],
                      categories: summaryData.trend.map(i =>
                        new Date(i.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                      ),
                      tickPlacement: 'on', // 🔥 important
                      labels: {
                        offsetX: 50 // 👈 manual adjustment
                      }
                    },
                    yaxis: {
                      min: 0,
                      max: 80
                    },
                    grid: {
                      padding: { left: 0, right: 0 }
                    }
                  }}
                />
              </Box>
            </Grid>

          </Grid>
        </Container>

        {/* {
            ux_distribution: datavalue?.data?.analytics?.ux_distribution,
            responsiveness_distribution: datavalue?.data?.analytics?.responsiveness_distribution,
            pass_fail_breakdown: datavalue?.data?.analytics?.pass_fail_breakdown,
            top_5_pages: datavalue.data.top_5_pages,
            bottom_5_pages: datavalue.data.bottom_5_pages,
            trend: datavalue.data.trend,
          } */}


        <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap">
                  {performancePlan.status ?
                    <div>

                      <DatagridComp
                        columns={columns}
                        rows={rows}
                        autoheightval={autoheightval}
                        datagridval={2}
                        columnFreezeWidth={[0, 320]}
                        tableLoading={tableLoading}
                        handleModelPopUp={handleModelPopUp}
                        handleDownlodingCSV={handleDownlodingCSV}
                        handleDownlodingPDF={handleDownlodingPDF}
                        customFilter={true}
                        DownloadShowFile={true}
                        DownloadShowPDF={1}
                        DownloadShowCSV={2}
                      // paginationData={getPagination}
                      />
                    </div> : <Freeaudit planStatus={performancePlan} />
                  }
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand"> Elite site Optimizer</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        {/* <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Technical' },
            { title: 'Performance', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />

            </button>
            {performancePlan.status &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>Performance</h2>
              <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={openModal} />
              </span>
            </div>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>
          </div>
          <div className="cnt_hdr_top_rgt_wrap">
            <div title="Domain Section">
              <Select
                options={SectionOptions}
                name="name"
                onChange={SetSectionNameHandle}
                placeholder="Domain Section"
                styles={customDropdownStyles()}
                menuPortalTarget={document.body}
                classNamePrefix="common-domain-dropdown"
              />
            </div>
            <button
              title="Run Report"
              className="runreportnew over_all_accessibility"
              onClick={() => {
                if (first.statusDomain) {
                  setcheckD(first.statusDomain);
                } else {
                  setfaqData(2)
                  setToggle(false)
                  SetRunReportPopShow(true);
                }
              }}
              disabled={!performancePlan.status}
              style={{ letterSpacing: "0.8px", width: "150px", lineHeight: "12px" }}
            >
              Run Report Now
            </button>
          </div>
        </div>

        {performancePlan.status ?
          <div>

            <div className="common-card-container" style={{ justifyContent: "center" }}>
              {cardDatas.map(({ title, value, iconSrc, altText }) => (
                <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
              ))}
            </div>


            <DatagridComp
              columns={columns}
              rows={rows}
              autoheightval={autoheightval}
              datagridval={2}
              columnFreezeWidth={[0, 320]}
              tableLoading={tableLoading}
            />
          </div> : <Freeaudit planStatus={performancePlan} />
        } */}
      </div>
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">

              <div>

                <div className="">
                  <div>
                    <span>Completed Date</span>
                    <Select
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values)
                        SetdEngineoption(values);
                        setValidation({
                          dateerror: "",
                        })
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>


                </div>
                <span className="text-error">{validation.dateerror}</span>
              </div>

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <button className="form_submit_btn" onClick={reportNow} style={{ cursor: 'pointer' }} >
            Submit
          </button>
          <button style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
          <button style={{ cursor: 'pointer' }} onClick={handleReset}>Reset</button>
          {/* <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button> */}
        </DialogActions>
      </Dialog>

      {!openCommonAlerts &&
        <>
          <CommonErrorAlert
            data={{
              apiopen: open,
              apiErrorMsg: 'No Data Found',
              isIconStyled: true
            }}
            closeAlert={handleClose} />
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        </>
      }
      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Please verify your domain to access these features
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
          <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
        </DialogActions>
      </Dialog>
      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
        isDomainSection={true}
      />
      <UserActivityTracker pagename="Technical - Performance Analysis - UX Analysis" />
    </ div>
  );
}
